function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 100 100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("title", null, "Checkbox"), React.createElement("circle", {
  id: "checkbox-Oval-7-Copy",
  className: styles["checkbox-circle-borderd"] || "checkbox-circle-borderd",
  fill: "none",
  cx: "50",
  cy: "50",
  r: "48"
}), React.createElement("circle", {
  id: "checkbox-Oval-7-Copy",
  className: styles["checkbox-circle-filled"] || "checkbox-circle-filled",
  fill: "#A5A500",
  cx: "50",
  cy: "50",
  r: "50"
}), React.createElement("path", {
  id: "checkbox-Path",
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M30.4807041 47.8199359L25 53.7461498 44.2371832 72 75 31.9753911 68.6738596 27 43.3147797 59.9907919z"
})));